import { createStore, withProps } from '@ngneat/elf';
import { SelectOption } from '@/components/form-builder/form-builder.types';
import { Committee, CommitteeDto, User } from '@/types';
import { Observable, of } from 'rxjs';

export interface CommitteeStateProps {
  response?: Partial<Committee>;
  dto?: Partial<CommitteeDto>;
  comTypeIdSelected?: SelectOption;
  membersSelected?: SelectOption[];
  tuttelSelected?: SelectOption;
  paysSelected?: SelectOption;
  memberToDelete?: User;
  comTypeOptions?: SelectOption[];
  memberOptions?: SelectOption[];
  isDisabled?: Observable<Record<keyof CommitteeDto, boolean>>;
  formSubmitted?: boolean;
  // Error states
  nomError?: boolean;
  ancrageError?: boolean;
  decretCreationError?: boolean;
  comTypeIdError?: boolean;
  theAdresseError?: boolean;
  contactError?: boolean;
  responsableError?: boolean;
  emailError?: boolean;
  // Touched states
  nomTouched?: boolean;
  ancrageTouched?: boolean;
  decretCreationTouched?: boolean;
  comTypeIdTouched?: boolean;
  theAdresseTouched?: boolean;
  contactTouched?: boolean;
  responsableTouched?: boolean;
  tutelIdTouched?: boolean;
  memberSelected?: SelectOption;
}

export const committeeInitialState: CommitteeStateProps = {
  response: {
    id: 0,
    nom: '',
    abreviation: '',
    nomAr: '',
    decretCreation: '',
    responsableId: '',
    special: false,
    ancrage: '',
    adresse: '',
    users: [],
    tutel: { id: 0, nom: '' },
    contact: '',
  },
  dto: {
    nom: '',
    abreviation: '',
    nomAr: '',
    decretCreation: '',
    responsableId: '',
    special: false,
    ancrage: null,
    tutelId: null,
    theAdresse: {
      id: undefined,
      tel1: '',
      tel2: '',
      fax: '',
      adresse: '',
      compAdresse: '',
      codePostal: '',
      ville: '',
      paysId: null,
      email: '',
    },
    contact: null,
    comTypeId: 0,
    userIds: [],
    files: [],
    docIds: [],
    docs: [],
  },
  comTypeIdSelected: { name: '', code: 0 },
  membersSelected: [],
  memberToDelete: undefined,
  tuttelSelected: undefined,
  comTypeOptions: [],
  memberOptions: [],
  formSubmitted: false,
  // Initialize error states
  nomError: false,
  ancrageError: false,
  decretCreationError: false,
  comTypeIdError: false,
  theAdresseError: false,
  contactError: false,
  responsableError: false,
  emailError: false,
  // Initialize touched states
  nomTouched: false,
  ancrageTouched: false,
  decretCreationTouched: false,
  comTypeIdTouched: false,
  theAdresseTouched: false,
  contactTouched: false,
  responsableTouched: false,
  isDisabled: of({
    nom: false,
    abreviation: false,
    nomAr: false,
    decretCreation: false,
    responsableId: false,
    special: false,
    ancrage: false,
    comTypeId: false,
    tutelId: false,
    theAdresse: false,
    contact: false,
    userIds: false,
    consellierIds: false,
    files: false,
    docIds: false,
    docs: false,
  }),
  memberSelected: undefined,
};

export const comitteeStateStore = createStore({ name: 'committee-state' }, withProps<CommitteeStateProps>({ ...committeeInitialState }));
